import { Tkv2ReferenceViewModule } from '../../modules/referenceView/Tkv2ReferenceViewModule.tsx';

export const CraftsmanAlertsSheetRouteElement = () => {
  return <Tkv2ReferenceViewModule isPopout dataSheet="craftsman-alerts" />;
};
